<template>

    <ui-select
      :name="name"
      :label="label"
      :keys="keys"
      :value="model"
      @input="onInput"
      :options="options"
      :placeholder="placeholder"
      :multiple="false"
      :required="required"
    ></ui-select>
    
</template>
<script>
import Utils from './../services/Utils'

export default {
  props: {
    value: {
      type: [String, Number, Array],
      default: -1
    },
    options: {
      type: Array,
      default () {
        return []
      }
    },
    name: {
      type: String,
      default: 'unknownName'
    },
    required: {
      type: Boolean,
      default: true
    },
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    keys: {
      type: Object,
      default () {
        return Utils.keysForSelect()
      }
    }
  },
  data () {
    return {
      model: this.getBaseModel()
    }
  },
  methods: {
    getBaseModel () {
      return {
        [this.keys.value]: null,
        [this.keys.label]: ''
      }
    },
    onInput (e) {
      this.selectValue(e[this.keys.value])
    },
    selectValue (id) {
      const foundObj = this.changeValue(id)

      if (!foundObj.found) {
        this.clearModel()
      } else {
        this.emitValue(foundObj.value)
      }
    },
    emitValue (value) {
      this.$emit('input', value)
    },
    changeValue (id) {
      let found = false
      let value = null

      this.options.map((el, i) => {
        if (el[this.keys.value] === id) {
          this.model = this.options[i]
          found = true
          value = id
        }
      })

      return {found, value}
    },
    clearModel () {
      this.model = {
        [this.keys.value]: null,
        [this.keys.label]: ''
      }
    }
  },
  watch: {
    value: function (n, o) {
      if (n !== o) {
        this.selectValue(n)
      }
    },
    options: function (n, o) {
      this.selectValue(this.value)
    }
  },
  mounted () {
    this.selectValue(this.value)
  }
}
</script>


// WEBPACK FOOTER //
// ISelectSimple.vue?09bdcf3e